// import 'rangeslider';
import '../plugins/rangeslider';

function init() {
	$( document ).ready(function() {
		const cssClasses = [
			'rangeslider--is-20-value',
			'rangeslider--is-40-value',
			'rangeslider--is-60-value',
			'rangeslider--is-80-value',
			'rangeslider--is-100-value'
		];

		$('input[type=range]').rangeslider({
			polyfill: false,

			// Default CSS classes
			rangeClass: 'rangeslider',
			disabledClass: 'rangeslider--disabled',
			horizontalClass: 'rangeslider--horizontal',
			fillClass: 'rangeslider__fill',
			handleClass: 'rangeslider__handle',

			// Callback function
			onInit: function() {
				var $rangeEl = this.$range;

				// get range index labels
				var rangeLabels = this.$element.attr('labels');
				rangeLabels = rangeLabels.split(', ');

				// add labels
				$rangeEl.append('<div class="rangeslider__labels row align-justify"></div>');

				$(rangeLabels).each(function(index, value) {
					let value_text = value.trim();

					if (value_text === '100%') {
						let value_text = '100%';
						$rangeEl.find('.rangeslider__labels').append('<span class="rangeslider__labels__label">100%</span>');
					} else {
						$rangeEl.find('.rangeslider__labels').append('<span class="rangeslider__labels__label">' + value_text + '</span>');
					}
				})
			},

			onSlideEnd: function(position, value) {

			}
		})

		.on('input', function() {
			const fraction = (this.value - this.min) / (this.max - this.min);
			if (fraction === 0.2) {
				this.nextSibling.classList.remove(...cssClasses)
				this.nextSibling.classList.add(cssClasses[0]);
			} else if (fraction === 0.4) {
				this.nextSibling.classList.remove(...cssClasses)
				this.nextSibling.classList.add(cssClasses[1]);
			} else if (fraction === 0.6) {
				this.nextSibling.classList.remove(...cssClasses)
				this.nextSibling.classList.add(cssClasses[2]);
			} else if (fraction === 0.8) {
				this.nextSibling.classList.remove(...cssClasses)
				this.nextSibling.classList.add(cssClasses[3]);
			} else if (fraction === 1) {
				this.nextSibling.classList.remove(...cssClasses)
				this.nextSibling.classList.add(cssClasses[4]);
			}
		});

		//custom slider javascript
		$(function() {
			$(document).on('input', 'input[type="range"]', function(e) {
				var output = document.querySelectorAll('h3#output')[0];
				var percentage = document.querySelector('#percentage-value');
				var graph = document.querySelector('#percentage-graph');
				var percent_bar = document.getElementById('js-rangeslider-0').childNodes[0];
				var percent_handle = document.getElementById('js-rangeslider-0').childNodes[1];

				console.log(percent_handle);

				if (e.currentTarget.value == 0) {
					output.classList.remove(...cssClasses);
					output.innerHTML = $("#percentage-0").html();
					graph.classList.remove(...cssClasses);
					percentage.classList.remove(...cssClasses);

					percent_handle.classList.remove(...cssClasses);
					percent_bar.classList.remove(...cssClasses);

					percentage.innerHTML = "0%";
				} else if (e.currentTarget.value == 20) {
					output.classList.remove(...cssClasses);
					output.classList.add(cssClasses[0]);
					output.innerHTML = $("#percentage-20").html();
					graph.classList.remove(...cssClasses);
					graph.classList.add(cssClasses[0]);

					percent_handle.classList.remove(...cssClasses); // strip them
					percent_handle.classList.add(cssClasses[0]);    // add it
					percent_bar.classList.remove(...cssClasses);    // strip them
					percent_bar.classList.add(cssClasses[0]);       // add it

					percentage.classList.remove(...cssClasses);
					percentage.innerHTML = "20%";
				} else if (e.currentTarget.value == 40) {
					output.classList.remove(...cssClasses);
					output.classList.add(cssClasses[1]);
					output.innerHTML = $("#percentage-40").html();
					graph.classList.remove(...cssClasses);
					graph.classList.add(cssClasses[1]);

					percent_handle.classList.remove(...cssClasses);
					percent_handle.classList.add(cssClasses[1]);
					percent_bar.classList.remove(...cssClasses);
					percent_bar.classList.add(cssClasses[1]);

					percentage.classList.remove(...cssClasses);
					percentage.innerHTML = "40%";
				} else if (e.currentTarget.value == 60) {
					output.classList.remove(...cssClasses);
					output.classList.add(cssClasses[2]);
					output.innerHTML = $("#percentage-60").html();
					graph.classList.remove(...cssClasses);
					graph.classList.add(cssClasses[2]);

					percent_handle.classList.remove(...cssClasses);
					percent_handle.classList.add(cssClasses[2]);
					percent_bar.classList.remove(...cssClasses);
					percent_bar.classList.add(cssClasses[2]);

					percentage.classList.remove(...cssClasses);
					percentage.innerHTML = "60%";
				} else if (e.currentTarget.value == 80) {
					output.classList.remove(...cssClasses);
					output.classList.add(cssClasses[3]);
					output.innerHTML = $("#percentage-80").html();
					graph.classList.remove(...cssClasses);
					graph.classList.add(cssClasses[3]);

					percent_handle.classList.remove(...cssClasses);
					percent_handle.classList.add(cssClasses[3]);
					percent_bar.classList.remove(...cssClasses);
					percent_bar.classList.add(cssClasses[3]);

					percentage.classList.remove(...cssClasses);
					percentage.innerHTML = "90%";
				} else if (e.currentTarget.value == 100) {
					output.classList.remove(...cssClasses);
					output.classList.add(cssClasses[4]);
					output.innerHTML = $("#percentage-100").html();
					graph.classList.remove(...cssClasses);
					graph.classList.add(cssClasses[4]);

					percent_handle.classList.remove(...cssClasses);
					percent_bar.classList.remove(...cssClasses);

					percentage.classList.remove(...cssClasses);
					percentage.innerHTML = "100%";
				}
			});
		});

	});

}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/rangeslider-setup.js